// Mapping IDs stables - ne pas modifier les valeurs, seulement ajouter
export const STEP_IDS = {
  1: 'STEP_PROFILE',
  2: 'STEP_CHILDREN',
  3: 'STEP_PARTNER',
  4: 'STEP_HOUSING',
  5: 'STEP_RESOURCES',
  6: 'STEP_FINAL_QUESTIONS',
  7: 'STEP_RESULTS',
  8: 'STEP_TAX_INCOME'
};

export const STEP_LABELS = {
  1: 'Mon profil',
  2: 'Mes enfants à charge',
  3: 'Conjoint(e)',
  4: 'Mon logement',
  5: 'Ressources',
  6: 'Avant de terminer',
  7: 'Résultats',
  8: 'Revenus imposables N-2'
};

// Mapping des champs par étape (clé locale → ID stable)
export const FIELD_IDS = {
  STEP_PROFILE: {
    age: 'FIELD_AGE',
    nationalite: 'FIELD_NATIONALITY',
    duree_sejour_valide: 'FIELD_RESIDENCE_DURATION',
    situation_etudiant: 'FIELD_IS_STUDENT',
    situation_retraite: 'FIELD_IS_RETIRED',
    situation_chomeur: 'FIELD_IS_UNEMPLOYED',
    situation_handicap: 'FIELD_IS_DISABLED',
    situation_inapte: 'FIELD_IS_UNABLE_TO_WORK',
    situation_enceinte: 'FIELD_IS_PREGNANT',
    situation_aucune: 'FIELD_NO_SITUATION',
    echelon_bourse: 'FIELD_SCHOLARSHIP_LEVEL',
    taux_incapacite: 'FIELD_DISABILITY_RATE',
    date_fin_contrat: 'FIELD_CONTRACT_END_DATE',
    ass_precondition: 'FIELD_ASS_PRECONDITION',
    cdaph_restriction: 'FIELD_CDAPH_RESTRICTION',
    gir: 'FIELD_GIR',
    declaration_fiscale: 'FIELD_TAX_DECLARATION',
    rsa_heures: 'FIELD_RSA_HOURS'
  },
  STEP_CHILDREN: {
    has_children: 'FIELD_HAS_CHILDREN',
    child_age: 'FIELD_CHILD_AGE',
    child_nationality: 'FIELD_CHILD_NATIONALITY',
    child_situation: 'FIELD_CHILD_SITUATION'
  },
  STEP_PARTNER: {
    en_couple: 'FIELD_HAS_PARTNER',
    statut_marital: 'FIELD_MARITAL_STATUS',
    isolement_recent: 'FIELD_RECENT_ISOLATION',
    conjoint_age: 'FIELD_PARTNER_AGE',
    conjoint_nationalite: 'FIELD_PARTNER_NATIONALITY',
    conjoint_situation: 'FIELD_PARTNER_SITUATION'
  },
  STEP_HOUSING: {
    statut_occupation: 'FIELD_HOUSING_STATUS',
    code_postal: 'FIELD_POSTAL_CODE',
    ville: 'FIELD_CITY',
    colocation: 'FIELD_IS_SHARED',
    proprietaire_proche: 'FIELD_LANDLORD_RELATION',
    type_location: 'FIELD_RENTAL_TYPE',
    is_chambre: 'FIELD_IS_ROOM',
    loyer: 'FIELD_RENT',
    charges: 'FIELD_CHARGES',
    primo_accedant: 'FIELD_FIRST_TIME_BUYER',
    mensualites: 'FIELD_MONTHLY_PAYMENTS',
    paye_frais_logement: 'FIELD_PAYS_HOUSING_COSTS',
    question_demenagement: 'FIELD_MOVING_SOON',
    question_difficultes: 'FIELD_FINANCIAL_DIFFICULTIES',
    question_travaux: 'FIELD_RENOVATION_PLANS',
    question_achat: 'FIELD_PURCHASE_INTEREST',
    reduction_eligibility: 'FIELD_REDUCTION_CHOICE'
  },
  STEP_RESOURCES: {
    salaire: 'FIELD_SALARY',
    chomage: 'FIELD_UNEMPLOYMENT_BENEFITS',
    retraite: 'FIELD_RETIREMENT_PENSION',
    indemnites_maladie: 'FIELD_SICK_LEAVE',
    revenus_locatifs: 'FIELD_RENTAL_INCOME',
    auto_entrepreneur: 'FIELD_SELF_EMPLOYED',
    micro_entrepreneur: 'FIELD_MICRO_ENTREPRENEUR',
    exploitant_agricole: 'FIELD_FARMER',
    profession_liberale: 'FIELD_LIBERAL_PROFESSION',
    child_resources: 'FIELD_CHILD_RESOURCES'
  },
  STEP_FINAL_QUESTIONS: {
    pension_alimentaire: 'FIELD_ALIMONY_PAID',
    pension_montant: 'FIELD_ALIMONY_AMOUNT',
    aide_permis: 'FIELD_DRIVING_LICENSE_AID',
    creation_entreprise: 'FIELD_BUSINESS_CREATION',
    aide_velo: 'FIELD_BIKE_AID',
    prix_velo: 'FIELD_BIKE_PRICE',
    type_velo: 'FIELD_BIKE_TYPE',
    contact_nom: 'FIELD_LAST_NAME',
    contact_prenom: 'FIELD_FIRST_NAME',
    contact_email: 'FIELD_EMAIL',
    contact_telephone: 'FIELD_PHONE'
  },
  STEP_TAX_INCOME: {
    revenus_activite: 'FIELD_WORK_INCOME',
    autres_revenus: 'FIELD_OTHER_INCOME',
    pensions_retraites: 'FIELD_PENSION_INCOME',
    frais_reels: 'FIELD_REAL_EXPENSES',
    pensions_percues: 'FIELD_ALIMONY_RECEIVED',
    pensions_versees: 'FIELD_ALIMONY_GIVEN',
    revenus_fonciers: 'FIELD_PROPERTY_INCOME'
  }
};

// Sections conditionnelles
export const CONDITIONAL_IDS = {
  // Étape Profil
  FOREIGN_RESIDENCE: 'COND_FOREIGN_RESIDENCE',
  STUDENT_SCHOLARSHIP: 'COND_STUDENT_SCHOLARSHIP',
  UNEMPLOYED_DATE: 'COND_UNEMPLOYED_DATE',
  UNEMPLOYED_ASS: 'COND_UNEMPLOYED_ASS',
  DISABILITY_RATE: 'COND_DISABILITY_RATE',
  DISABILITY_CDAPH: 'COND_DISABILITY_CDAPH',
  ELDERLY_GIR: 'COND_ELDERLY_GIR',
  YOUNG_TAX: 'COND_YOUNG_TAX',
  YOUNG_RSA: 'COND_YOUNG_RSA',

  // Étape Enfants
  CHILD_FORM: 'COND_CHILD_FORM',

  // Étape Conjoint
  PARTNER_FORM: 'COND_PARTNER_FORM',
  ISOLATION_DURATION: 'COND_ISOLATION_DURATION',

  // Étape Logement
  TENANT_DETAILS: 'COND_TENANT_DETAILS',
  OWNER_DETAILS: 'COND_OWNER_DETAILS',
  HOSTED_DETAILS: 'COND_HOSTED_DETAILS',
  COLOCATION_DETAILS: 'COND_COLOCATION_DETAILS',
  REDUCTION_ELIGIBILITY: 'COND_REDUCTION_ELIGIBILITY',
  MEETING_SELECTOR: 'COND_MEETING_SELECTOR',

  // Étape Ressources
  SALARY_DETAILS: 'COND_SALARY_DETAILS',
  SELF_EMPLOYED_DETAILS: 'COND_SELF_EMPLOYED_DETAILS',
  RESOURCE_MONTHLY: 'COND_RESOURCE_MONTHLY',

  // Étape Finale
  ALIMONY_AMOUNT: 'COND_ALIMONY_AMOUNT',
  BIKE_DETAILS: 'COND_BIKE_DETAILS',
  CONTACT_FORM: 'COND_CONTACT_FORM'
};

// Codes d'erreur avec leur type et champ associé
export const ERROR_CODES = {
  // Profil
  AGE_REQUIRED: { type: 'REQUIRED', field: 'FIELD_AGE' },
  AGE_INVALID: { type: 'FORMAT', field: 'FIELD_AGE' },
  SITUATION_REQUIRED: { type: 'REQUIRED', field: 'FIELD_SITUATION' },
  DATE_FORMAT_INVALID: { type: 'FORMAT', field: 'FIELD_CONTRACT_END_DATE' },

  // Logement
  HOUSING_STATUS_REQUIRED: { type: 'REQUIRED', field: 'FIELD_HOUSING_STATUS' },
  POSTAL_CODE_REQUIRED: { type: 'REQUIRED', field: 'FIELD_POSTAL_CODE' },
  POSTAL_CODE_FORMAT: { type: 'FORMAT', field: 'FIELD_POSTAL_CODE' },
  CITY_REQUIRED: { type: 'REQUIRED', field: 'FIELD_CITY' },
  RENT_REQUIRED: { type: 'REQUIRED', field: 'FIELD_RENT' },
  CHARGES_REQUIRED: { type: 'REQUIRED', field: 'FIELD_CHARGES' },
  RENTAL_TYPE_REQUIRED: { type: 'REQUIRED', field: 'FIELD_RENTAL_TYPE' },
  COLOCATION_REQUIRED: { type: 'REQUIRED', field: 'FIELD_IS_SHARED' },
  PAYMENTS_REQUIRED: { type: 'REQUIRED', field: 'FIELD_MONTHLY_PAYMENTS' },
  FIRST_TIME_BUYER_REQUIRED: { type: 'REQUIRED', field: 'FIELD_FIRST_TIME_BUYER' },
  HOSTED_FEES_REQUIRED: { type: 'REQUIRED', field: 'FIELD_PAYS_HOUSING_COSTS' },
  LANDLORD_RELATION_REQUIRED: { type: 'REQUIRED', field: 'FIELD_LANDLORD_RELATION' },
  IS_ROOM_REQUIRED: { type: 'REQUIRED', field: 'FIELD_IS_ROOM' },

  // Conjoint
  PARTNER_STATUS_REQUIRED: { type: 'REQUIRED', field: 'FIELD_HAS_PARTNER' },
  ISOLATION_DURATION_REQUIRED: { type: 'REQUIRED', field: 'FIELD_RECENT_ISOLATION' },

  // Finalisation
  ALIMONY_AMOUNT_REQUIRED: { type: 'REQUIRED', field: 'FIELD_ALIMONY_AMOUNT' },

  // Ressources
  RESOURCE_INVALID: { type: 'FORMAT', field: 'FIELD_RESOURCE' },

  // Contact
  LASTNAME_REQUIRED: { type: 'REQUIRED', field: 'FIELD_LAST_NAME' },
  FIRSTNAME_REQUIRED: { type: 'REQUIRED', field: 'FIELD_FIRST_NAME' },
  EMAIL_REQUIRED: { type: 'REQUIRED', field: 'FIELD_EMAIL' },
  EMAIL_FORMAT: { type: 'FORMAT', field: 'FIELD_EMAIL' },
  PHONE_REQUIRED: { type: 'REQUIRED', field: 'FIELD_PHONE' },
  PHONE_FORMAT: { type: 'FORMAT', field: 'FIELD_PHONE' },

  // Enfants / Conjoint
  CHILD_AGE_REQUIRED: { type: 'REQUIRED', field: 'FIELD_CHILD_AGE' },
  PARTNER_AGE_REQUIRED: { type: 'REQUIRED', field: 'FIELD_PARTNER_AGE' }
};

// Helper pour obtenir l'ID stable d'un champ
export const getFieldId = (stepNumber, fieldName) => {
  const stepId = STEP_IDS[stepNumber];
  const stepFields = FIELD_IDS[stepId];
  if (stepFields && stepFields[fieldName]) {
    return stepFields[fieldName];
  }
  // Fallback: retourne le nom du champ en majuscules
  return `FIELD_${fieldName.toUpperCase()}`;
};

// Helper pour obtenir les infos d'une erreur
export const getErrorInfo = (errorCode) => {
  return ERROR_CODES[errorCode] || { type: 'UNKNOWN', field: 'UNKNOWN' };
};
